(function() {
  const config = window.EG_CART_DRAWER_MEMBERSHIP;
  if (!config) return;

  const MEMBERSHIP_HANDLE = config.membershipHandle;
  const SELLING_PLAN_ID = config.membershipSellingPlanId;
  const MEMBERSHIP_PRODUCT_ID = config.membershipProductId;
  const MEMBERSHIP_ITEM_PRODUCT_ID = config.membershipItemProductId;
  const MEMBERSHIP_ITEM_VARIANT_ID = config.membershipItemVariantId;
  const MEMBERSHIP_VARIANT_ID = config.membershipVariantId;
  const MEMBERSHIP_GIFT_VARIANT_ID = config.membershipGiftVariantId;
  const MEMBERSHIP_GIFT_PROPERTY_KEY = config.membershipGiftPropertyKey;
  const MEMBERSHIP_GIFT_PROPERTY_VALUE = config.membershipGiftPropertyValue;
  const MEMBERSHIP_DRAWER_SECTIONS = config.drawerSections;
  const IS_GREENHOUSE_MEMBER = config.isGreenhouseMember === true;

  let membershipVariantId = MEMBERSHIP_VARIANT_ID || null;
  let membershipVariantPromise = null;
  let isProcessing = false;
  let membershipDelegatesBound = false;
  let latestCart = null;

  function hasFullCartSnapshot(cart) {
    return Boolean(cart && Array.isArray(cart.items) && typeof cart.item_count !== "undefined");
  }

  function hideMemberUpsellsForMembers() {
    if (!IS_GREENHOUSE_MEMBER) return false;

    document.querySelectorAll(
      ".cart-drawer__membership-upsell, .cart-drawer__membership-promo, .empty-cart-membership-promo"
    ).forEach((element) => {
      element.style.display = "none";
      element.setAttribute("hidden", "");
    });

    return true;
  }

  function setLatestCart(cart) {
    if (!hasFullCartSnapshot(cart)) {
      return latestCart;
    }

    latestCart = cart;
    window.cartState?.setCart(cart);
    return latestCart;
  }

  async function getMembershipVariantId() {
    if (membershipVariantId) return membershipVariantId;
    if (membershipVariantPromise) return membershipVariantPromise;

    membershipVariantPromise = fetch(`/products/${MEMBERSHIP_HANDLE}.js`)
      .then((response) => response.json())
      .then((product) => {
        membershipVariantId = product.variants[0].id;
        return membershipVariantId;
      })
      .catch((error) => {
        console.error("Failed to fetch membership product:", error);
        return null;
      })
      .finally(() => {
        membershipVariantPromise = null;
      });

    return membershipVariantPromise;
  }

  function publishMembershipCartUpdate(cartData) {
    setLatestCart(cartData);

    if (typeof publish !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "membership-checkbox",
        cartData
      });
    }

    document.dispatchEvent(new CustomEvent("cart:updated", {
      detail: {
        source: "membership-checkbox",
        cartData
      }
    }));
  }

  async function normalizeMembershipWelcomeGift(cart) {
    // membership-auto-add.js owns welcome-gift reconciliation when available.
    // Running a second normalizer here can race with the subscription-to-item
    // membership swap and re-add the gift from a stale cart snapshot.
    if (window.membershipLinkedProduct) {
      return cart;
    }

    if (typeof window.EGNormalizeMembershipWelcomeGift !== "function") {
      return cart;
    }

    const normalizedCart = await window.EGNormalizeMembershipWelcomeGift();
    return hasFullCartSnapshot(normalizedCart) ? setLatestCart(normalizedCart) : cart;
  }

  function renderMembershipDrawer(state, triggerId) {
    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer || typeof cartDrawer.renderContents !== "function" || !state?.sections) {
      return false;
    }

    if (typeof window.refreshCartDrawerHotZones === "function" && window.refreshCartDrawerHotZones(state, triggerId)) {
      return true;
    }

    cartDrawer.renderContents({
      sections: state.sections,
      id: triggerId
    });

    return true;
  }

  async function refreshMembershipDrawer(triggerId, cartSnapshot) {
    try {
      const root = window.Shopify?.routes?.root || "/";
      // EG_DOMAIN_MERGE_MEMBERSHIP_FRESH_DRAWER_SYNC
      const response = await fetch(
        `${root}?sections=${MEMBERSHIP_DRAWER_SECTIONS}&_=${Date.now()}`,
        { headers: { Accept: "application/json" }, cache: "no-store" }
      );
      if (!response.ok) return false;

      const sections = await response.json();
      return renderMembershipDrawer({ sections, item_count: cartSnapshot?.item_count }, triggerId);
    } catch (error) {
      console.warn("Unable to refresh membership cart sections:", error);
      return false;
    }
  }

  function syncCartBadgeCount(cart) {
    const itemCount = Number(cart?.item_count);
    const cartLink = document.getElementById("cart-icon-bubble");
    if (!cartLink || !Number.isFinite(itemCount)) return;

    let countBubble = cartLink.querySelector(".cart-count-bubble");
    if (itemCount <= 0) {
      countBubble?.remove();
      return;
    }

    if (!countBubble) {
      countBubble = document.createElement("div");
      countBubble.className = "cart-count-bubble";
      countBubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      cartLink.appendChild(countBubble);
    }

    const visibleCount = countBubble.querySelector('[aria-hidden="true"]');
    const accessibleCount = countBubble.querySelector(".visually-hidden");
    if (visibleCount) visibleCount.textContent = String(itemCount);
    if (accessibleCount) accessibleCount.textContent = `${itemCount} ${itemCount === 1 ? "item" : "items"}`;
  }

  async function getFreshCartSnapshot() {
    const cart = window.cartState?.getCart
      ? await window.cartState.getCart(true)
      : await fetch("/cart.js").then((response) => response.json());
    return setLatestCart(cart);
  }

  function showMembershipLoading() {
    let overlay = document.getElementById("membershipLoadingOverlay");

    if (!overlay) {
      overlay = document.createElement("div");
      overlay.id = "membershipLoadingOverlay";
      overlay.className = "membership-loading-overlay";
      overlay.innerHTML = `
        <div class="membership-loading-spinner">
          <svg class="spinner" viewBox="0 0 50 50">
            <circle class="path-bg" cx="25" cy="25" r="20" fill="none"></circle>
            <circle class="path" cx="25" cy="25" r="20" fill="none"></circle>
          </svg>
          <img
            class="membership-loading-icon"
            src="https://cdn.shopify.com/s/files/1/1337/8159/files/EG_Icon_1_5e5d37f8-ad1d-46ac-be60-420cb399fa50.png?v=1741928832"
            alt="Epic Gardening"
            width="30"
            height="30"
            loading="eager"
            decoding="async"
          >
          <p class="membership-loading-text">Updating membership...</p>
        </div>
      `;
    }

    const drawerInner = document.querySelector("cart-drawer .drawer__inner");
    if (drawerInner && overlay.parentNode !== drawerInner) {
      drawerInner.appendChild(overlay);
    } else if (!overlay.parentNode) {
      document.body.appendChild(overlay);
    }

    overlay.classList.add("active");
  }

  function hideMembershipLoading() {
    const overlay = document.getElementById("membershipLoadingOverlay");
    if (overlay) {
      overlay.classList.remove("active");
    }
  }

  function isMembershipLineItem(item, variantId) {
    if (!item) return false;

    if (item.properties?._gwp_gift === "true") return false;
    if (item.properties?.[MEMBERSHIP_GIFT_PROPERTY_KEY] === MEMBERSHIP_GIFT_PROPERTY_VALUE) return false;

    if (item.product_id === MEMBERSHIP_PRODUCT_ID) {
      return true;
    }

    return Boolean(
      variantId &&
      item.variant_id === variantId &&
      item.selling_plan_allocation?.selling_plan?.id == SELLING_PLAN_ID
    );
  }

  function getEligibleMembershipSavingsSubtotal(cart, membershipVariantId) {
    return cart.items.reduce((subtotalCents, item) => {
      if (item.properties?._gwp_gift === "true") return subtotalCents;
      if (item.properties?._bxgy_gift === "true") return subtotalCents;
      if (item.properties?.[MEMBERSHIP_GIFT_PROPERTY_KEY] === MEMBERSHIP_GIFT_PROPERTY_VALUE) return subtotalCents;
      if (isMembershipLineItem(item, membershipVariantId)) return subtotalCents;
      if (isGiftCardLineItem(item)) return subtotalCents;

      const membershipSavingsBase = hasMembershipLineDiscount(item)
        ? item.original_line_price
        : item.final_line_price;

      return subtotalCents + membershipSavingsBase;
    }, 0);
  }

  function hasMembershipLineDiscount(item) {
    const discounts = item.line_level_discount_allocations || item.discounts || [];

    return discounts.some((discount) => {
      const title = discount.discount_application?.title || discount.title || "";
      return title.trim().toLowerCase() === "greenhouse member discount";
    });
  }

  function isGiftCardLineItem(item) {
    if (!item) return false;
    if (item.gift_card === true || item.is_gift_card === true) return true;

    const giftCardText = [
      item.product_title,
      item.title,
      item.handle,
      item.product_type,
      item.vendor
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return (
      giftCardText.includes("gift card") ||
      giftCardText.includes("gift-card") ||
      giftCardText.includes("giftcard")
    );
  }

  async function updateMembershipSavings(cart) {
    const potentialSavingsEl = document.getElementById("potentialSavings");

    try {
      const variantId = await getMembershipVariantId();
      const eligibleSubtotalCents = getEligibleMembershipSavingsSubtotal(cart, variantId);
      const discountCents = Math.floor(eligibleSubtotalCents * 0.1);
      const memberTotalCents = Math.max(eligibleSubtotalCents - discountCents, 0);
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: cart.currency || "USD"
      });

      if (potentialSavingsEl) {
        potentialSavingsEl.textContent = formatter.format(discountCents / 100);
      }

      document.querySelectorAll("[data-membership-modal-current]").forEach((element) => {
        element.textContent = formatter.format(eligibleSubtotalCents / 100);
      });
      document.querySelectorAll("[data-membership-modal-after]").forEach((element) => {
        element.textContent = formatter.format(memberTotalCents / 100);
      });
      document.querySelectorAll("[data-membership-modal-saved]").forEach((element) => {
        element.textContent = discountCents > 0
          ? `Save ${formatter.format(discountCents / 100)} today`
          : "Member savings apply to eligible items";
      });
    } catch (error) {
      console.error("Failed to calculate membership savings:", error);
    }
  }

  let membershipModalTrigger = null;

  function getMembershipModal(trigger) {
    const modalId = trigger?.getAttribute("aria-controls");
    return modalId
      ? document.getElementById(modalId)
      : document.getElementById("MembershipBenefitsModal");
  }

  function populateMembershipModalBenefits(modal) {
    const target = modal?.querySelector("[data-membership-modal-benefits]");
    if (!target || target.children.length) return;

    const sourceItems = Array.from(
      document.querySelectorAll(".drawer__column--right .membership-promo__benefits li")
    ).slice(0, 6);
    const labels = [
      "10% off every order",
      "Free shipping & returns",
      "$20 welcome gift",
      "Free seed annually",
      "Garden Planner",
      "Expert Garden Help"
    ];

    sourceItems.forEach((item, index) => {
      const clone = item.cloneNode(true);
      const label = clone.querySelector("p");
      if (label) label.textContent = labels[index];
      target.appendChild(clone);
    });
  }

  function restoreMembershipModalFocus() {
    const trigger = membershipModalTrigger;
    membershipModalTrigger = null;
    if (trigger?.isConnected) {
      window.setTimeout(() => trigger.focus(), 0);
    }
  }

  function openMembershipDetails(trigger) {
    if (!window.matchMedia("(max-width: 989px)").matches) return;

    const modal = getMembershipModal(trigger);
    if (!modal) return;

    populateMembershipModalBenefits(modal);
    membershipModalTrigger = trigger;

    if (typeof modal.showModal === "function") {
      modal.showModal();
    } else {
      modal.setAttribute("open", "");
    }
  }

  function closeMembershipDetails(modal) {
    if (!modal) return;

    if (typeof modal.close === "function" && modal.open) {
      modal.close();
    } else {
      modal.removeAttribute("open");
    }
    restoreMembershipModalFocus();
  }

  function bindMembershipDelegates() {
    if (membershipDelegatesBound) return;
    membershipDelegatesBound = true;

    document.addEventListener("change", (event) => {
      if (event.target && event.target.id === "membershipCheckbox") {
        handleCheckboxChange(event);
      }
    });

    document.addEventListener("click", (event) => {
      const cartItem = event.target.closest?.(".cart-item");
      const removeControl = event.target.closest?.("cart-remove-button");

      if (cartItem && removeControl) {
        if (isMembershipGiftCartItem(cartItem)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        if (cartItem.dataset.membershipProduct === "true") {
          event.preventDefault();
          event.stopImmediatePropagation();
          handleMembershipLineRemoval();
          return;
        }
      }

      const detailsTrigger = event.target.closest("[data-membership-details-open]");
      if (detailsTrigger) {
        event.preventDefault();
        openMembershipDetails(detailsTrigger);
        return;
      }

      const detailsClose = event.target.closest("[data-membership-details-close]");
      if (detailsClose) {
        event.preventDefault();
        closeMembershipDetails(detailsClose.closest(".membership-benefits-modal"));
        return;
      }

      const detailsAdd = event.target.closest("[data-membership-details-add]");
      if (detailsAdd) {
        handleMembershipModalAdd(event, detailsAdd);
        return;
      }

      if (event.target.matches(".membership-benefits-modal")) {
        closeMembershipDetails(event.target);
        return;
      }

      const promoButton = event.target.closest(".membership-promo__cta");
      if (promoButton) {
        handleRightColumnCTA(event, promoButton);
      }
    }, true);

    document.addEventListener("cancel", (event) => {
      if (!event.target.matches?.(".membership-benefits-modal")) return;
      event.preventDefault();
      closeMembershipDetails(event.target);
    }, true);

    document.addEventListener("keyup", (event) => {
      if (
        event.code === "Escape" &&
        event.target.closest?.(".membership-benefits-modal")
      ) {
        event.stopPropagation();
      }
    }, true);
  }

  function hasMembershipInCart(cart, variantId) {
    return cart.items.some((item) =>
      (item.variant_id === variantId &&
        item.selling_plan_allocation?.selling_plan?.id == SELLING_PLAN_ID)
      || (config.membershipItemVariantId &&
        item.variant_id === config.membershipItemVariantId &&
        !item.selling_plan_allocation)
    );
  }

  function cartHasPreorder(cart) {
    return Boolean(cart?.items?.some((item) => Object.entries(item.properties || {}).some(([key, value]) => {
      const normalizedKey = String(key).toLowerCase();
      const normalizedValue = String(value || '').toLowerCase();
      return normalizedKey.includes('purple dot')
        || normalizedKey.includes('pre-order')
        || normalizedKey.includes('preorder')
        || normalizedValue.includes('purple dot')
        || normalizedValue.includes('pre-order')
        || normalizedValue.includes('preorder');
    })));
  }

  function shouldBlockMembershipPurchase(cart) {
    return cartHasPreorder(cart) && Boolean(
      config.membershipItemVariantId &&
      cart.items.some((item) => item.variant_id === config.membershipItemVariantId && !item.selling_plan_allocation)
    );
  }

  async function addMembership(variantId, cartOverride) {
    if (window.membershipLinkedProduct?.addMembership) {
      const cart = await window.membershipLinkedProduct.addMembership(cartOverride);
      if (hasFullCartSnapshot(cart)) {
        setLatestCart(cart);
        syncCartBadgeCount(cart);
        await window.membershipLinkedProduct.renderCartDrawerAfterMembershipAdd(variantId, cart);
        // Keep GWP and other cart listeners current without asking CartItems to
        // render the same membership sections a second time.
        publishMembershipCartUpdate(cart);
        requestAnimationFrame(() => initializeCartUI(cart));
      }
      return cart;
    }

    const currentCart = await resolveCartSnapshot(cartOverride);
    if (shouldBlockMembershipPurchase(currentCart)) return currentCart;
    const useMembershipItem = cartHasPreorder(currentCart) && config.membershipItemVariantId;
    const hasMembershipAlready = currentCart.items.some((item) =>
      item.variant_id === variantId &&
      item.selling_plan_allocation?.selling_plan?.id == SELLING_PLAN_ID
    ) || currentCart.items.some((item) =>
      useMembershipItem && item.variant_id === config.membershipItemVariantId && !item.selling_plan_allocation
    );

    if (hasMembershipAlready) {
      return currentCart;
    }

    const hasGiftAlready = currentCart.items.some((item) =>
      item.variant_id?.toString() === MEMBERSHIP_GIFT_VARIANT_ID.toString() &&
      item.properties?.[MEMBERSHIP_GIFT_PROPERTY_KEY] === MEMBERSHIP_GIFT_PROPERTY_VALUE
    );

    const body = {
      items: [
        {
          id: useMembershipItem ? config.membershipItemVariantId : variantId,
          quantity: 1,
          ...(useMembershipItem ? {} : { selling_plan: SELLING_PLAN_ID })
        },
        ...(hasGiftAlready ? [] : [{
          id: MEMBERSHIP_GIFT_VARIANT_ID,
          quantity: 1,
          properties: {
            [MEMBERSHIP_GIFT_PROPERTY_KEY]: MEMBERSHIP_GIFT_PROPERTY_VALUE,
            _linked_to_product: MEMBERSHIP_PRODUCT_ID
          }
        }])
      ],
      sections: MEMBERSHIP_DRAWER_SECTIONS,
      sections_url: window.location.pathname
    };

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.description || "Failed to add to cart");
    }

    const result = await response.json();
    let fullCart = hasFullCartSnapshot(result)
      ? setLatestCart(result)
      : await getFreshCartSnapshot();
    const normalizedCart = await normalizeMembershipWelcomeGift(fullCart);
    fullCart = normalizedCart;

    publishMembershipCartUpdate(fullCart);

    // Shopify can return stale rendered sections for a multi-item cart/add response.
    // Fetch the final cart sections after normalization so the drawer and badge agree.
    if (!await refreshMembershipDrawer(variantId, fullCart)) {
      renderMembershipDrawer({ ...result, item_count: fullCart.item_count }, variantId);
    }
    syncCartBadgeCount(fullCart);

    requestAnimationFrame(() => initializeCartUI(fullCart));

    return fullCart;
  }

  async function removeMembership(variantId, cartOverride) {
    if (window.membershipLinkedProduct?.removeMembership) {
      const cart = await window.membershipLinkedProduct.removeMembership(cartOverride);
      if (hasFullCartSnapshot(cart)) {
        setLatestCart(cart);
        syncCartBadgeCount(cart);
        requestAnimationFrame(() => initializeCartUI(cart));
      }
      return cart;
    }

    const cart = await resolveCartSnapshot(cartOverride);
    const membershipItem = cart.items.find((item) =>
      item.variant_id === variantId &&
      item.selling_plan_allocation?.selling_plan?.id == SELLING_PLAN_ID
    ) || cart.items.find((item) =>
      config.membershipItemVariantId &&
      item.variant_id === config.membershipItemVariantId &&
      !item.selling_plan_allocation
    );

    if (!membershipItem) {
      return cart;
    }

    const updates = { [membershipItem.key]: 0 };
    cart.items
      .filter((item) => item.properties?.[MEMBERSHIP_GIFT_PROPERTY_KEY] === MEMBERSHIP_GIFT_PROPERTY_VALUE)
      .forEach((item) => {
        updates[item.key] = 0;
      });

    const updateResponse = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates,
        sections: MEMBERSHIP_DRAWER_SECTIONS,
        sections_url: window.location.pathname
      })
    });

    if (!updateResponse.ok) {
      throw new Error("Failed to remove from cart");
    }

    let finalCart = await updateResponse.json();
    if (hasFullCartSnapshot(finalCart)) {
      setLatestCart(finalCart);
    }
    const itemToUpdate = finalCart.items.find((item) =>
      item.properties?._gwp_gift !== "true" &&
      item.properties?.[MEMBERSHIP_GIFT_PROPERTY_KEY] !== MEMBERSHIP_GIFT_PROPERTY_VALUE &&
      item.variant_id !== variantId
    );

    if (itemToUpdate && cartHasMembershipDiscounts(finalCart)) {
      const touchResponse = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: itemToUpdate.key,
          quantity: itemToUpdate.quantity,
          sections: MEMBERSHIP_DRAWER_SECTIONS,
          sections_url: window.location.pathname
        })
      });

      if (touchResponse.ok) {
        finalCart = await touchResponse.json();
        if (hasFullCartSnapshot(finalCart)) {
          setLatestCart(finalCart);
        }
      }
    }

    const fullCart = hasFullCartSnapshot(finalCart)
      ? setLatestCart(finalCart)
      : await getFreshCartSnapshot();

    publishMembershipCartUpdate(fullCart);

    if (!renderMembershipDrawer(finalCart, variantId)) {
      await refreshMembershipDrawer(variantId);
    }

    requestAnimationFrame(() => initializeCartUI(fullCart));

    return fullCart;
  }

  async function handleCheckboxChange(event) {
    if (isProcessing) {
      event.preventDefault();
      return;
    }

    const checkbox = event.target;
    const isChecked = checkbox.checked;
    isProcessing = true;
    checkbox.disabled = true;
    showMembershipLoading();

    try {
      const variantId = await getMembershipVariantId();
      if (!variantId) throw new Error("Could not load membership product");

      if (isChecked) {
        await addMembership(variantId, latestCart);
      } else {
        await removeMembership(variantId, latestCart);
      }
    } catch (error) {
      console.error("Error toggling membership:", error);
      checkbox.checked = !isChecked;
      alert("Unable to update membership. Please try again.");
    } finally {
      checkbox.disabled = false;
      isProcessing = false;
      hideMembershipLoading();
    }
  }

  async function handleRightColumnCTA(event, button) {
    event.preventDefault();
    if (isProcessing) return;

    const originalText = button.textContent;
    isProcessing = true;
    button.disabled = true;
    button.textContent = "Adding...";
    showMembershipLoading();

    try {
      const variantId = await getMembershipVariantId();
      if (!variantId) throw new Error("Could not load membership product");

      await addMembership(variantId, latestCart);
      button.textContent = "Added!";
    } catch (error) {
      console.error("Error adding membership:", error);
      button.textContent = originalText;
      alert("Unable to add membership. Please try again.");
    } finally {
      button.disabled = false;
      isProcessing = false;
      hideMembershipLoading();
    }
  }

  async function handleMembershipModalAdd(event, button) {
    event.preventDefault();
    if (isProcessing) return;

    const modal = button.closest(".membership-benefits-modal");
    const originalText = button.textContent;
    isProcessing = true;
    button.disabled = true;
    button.textContent = "Adding...";
    showMembershipLoading();

    try {
      const variantId = await getMembershipVariantId();
      if (!variantId) throw new Error("Could not load membership product");

      await addMembership(variantId, latestCart);
      if (modal?.isConnected) {
        closeMembershipDetails(modal);
      } else {
        membershipModalTrigger = null;
      }
    } catch (error) {
      console.error("Error adding membership from details modal:", error);
      button.textContent = originalText;
      alert("Unable to add membership. Please try again.");
    } finally {
      if (button.isConnected) {
        button.disabled = false;
      }
      isProcessing = false;
      hideMembershipLoading();
    }
  }

  function disableMembershipQuantityControls() {
    const membershipVariantIds = new Set(
      [MEMBERSHIP_VARIANT_ID, MEMBERSHIP_ITEM_VARIANT_ID]
        .filter(Boolean)
        .map((id) => String(id))
    );
    const membershipProductIds = new Set(
      [MEMBERSHIP_PRODUCT_ID, MEMBERSHIP_ITEM_PRODUCT_ID]
        .filter(Boolean)
        .map((id) => String(id))
    );

    document.querySelectorAll(".cart-item").forEach((item) => {
      const membershipCopy = item.textContent.toLowerCase();
      const isMembershipGift = isMembershipGiftCartItem(item);
      const isMembership = item.dataset.membershipProduct === "true"
        || membershipProductIds.has(String(item.dataset.productId || ""))
        || membershipVariantIds.has(String(item.dataset.variantId || item.querySelector(".quantity__input")?.dataset.quantityVariantId || ""))
        || membershipCopy.includes("annual membership")
        || membershipCopy.includes("one-time payment");
      if (!isMembership && !isMembershipGift) return;

      const quantityInput = item.querySelector(".quantity__input");
      const plusButton = item.querySelector('button[name="plus"]');
      const minusButton = item.querySelector('button[name="minus"]');

      [quantityInput, plusButton, minusButton].forEach((element) => {
        if (!element) return;
        element.disabled = true;
        element.style.opacity = "0.5";
        element.style.cursor = "not-allowed";
        if (element.tagName === "BUTTON") {
          element.style.pointerEvents = "none";
        }
      });

      if (isMembershipGift) {
        const removeControl = item.querySelector("cart-remove-button button, cart-remove-button a");
        if (removeControl) {
          removeControl.disabled = true;
          removeControl.setAttribute("aria-disabled", "true");
          removeControl.style.pointerEvents = "none";
        }
      }
    });
  }

  function isMembershipGiftCartItem(item) {
    if (!item) return false;
    if (item.dataset.membershipGift === "true") return true;

    const lineKey = item.dataset.lineKey;
    return Boolean(lineKey && latestCart?.items?.some((cartItem) => (
      cartItem.key === lineKey
      && cartItem.properties?.[MEMBERSHIP_GIFT_PROPERTY_KEY] === MEMBERSHIP_GIFT_PROPERTY_VALUE
    )));
  }

  async function handleMembershipLineRemoval() {
    if (isProcessing) return;

    isProcessing = true;
    showMembershipLoading();

    try {
      const variantId = await getMembershipVariantId();
      if (!variantId) throw new Error("Could not load membership product");
      await removeMembership(variantId, latestCart);
    } catch (error) {
      console.error("Error removing membership:", error);
      alert("Unable to update membership. Please try again.");
    } finally {
      isProcessing = false;
      hideMembershipLoading();
    }
  }

  function cartHasMembershipDiscounts(cart) {
    return Boolean(cart?.items?.some((item) => hasMembershipLineDiscount(item)));
  }

  async function resolveCartSnapshot(cartOverride, options = {}) {
    const { forceFresh = false } = options;

    if (hasFullCartSnapshot(cartOverride)) {
      return setLatestCart(cartOverride);
    }

    if (!forceFresh && hasFullCartSnapshot(latestCart)) {
      return latestCart;
    }

    const cart = window.cartState?.getCart
      ? await window.cartState.getCart(forceFresh)
      : await fetch("/cart.js").then((response) => response.json());
    return setLatestCart(cart);
  }

  async function initializeCartUI(cartOverride) {
    try {
      if (hideMemberUpsellsForMembers()) return;

      const [cart, variantId] = await Promise.all([
        resolveCartSnapshot(cartOverride, {
          forceFresh: !hasFullCartSnapshot(cartOverride)
        }),
        getMembershipVariantId()
      ]);

      setLatestCart(cart);

      await updateMembershipSavings(cart);
      disableMembershipQuantityControls();

      if (!variantId) return;

      const hasMembership = hasMembershipInCart(cart, variantId);
      const membershipCheckbox = document.getElementById("membershipCheckbox");
      if (membershipCheckbox) {
        membershipCheckbox.checked = hasMembership;
        membershipCheckbox.disabled = shouldBlockMembershipPurchase(cart);
      }

      const promoButton = document.querySelector(".membership-promo__cta");
      const promoContainer = document.querySelector(".cart-drawer__membership-promo");

      if (promoButton && promoContainer) {
        const existingMessage = promoContainer.querySelector(".membership-promo__added");
        if (existingMessage) {
          existingMessage.remove();
        }

        if (hasMembership) {
          promoButton.style.display = "none";

          const messageEl = document.createElement("p");
          messageEl.className = "membership-promo__added";
          messageEl.style.cssText = "color: #00765E; font-weight: 600; text-align: center; margin-top: 16px; border-radius: 8px;";
          messageEl.textContent = "✓ Membership in cart";
          promoButton.parentNode.insertBefore(messageEl, promoButton.nextSibling);
        } else {
          promoButton.style.display = "";
          promoButton.disabled = false;
        }
      }
    } catch (error) {
      console.error("Failed to initialize cart UI:", error);
    }
  }

  async function enforceMembershipQuantity(cart) {
    if (window.membershipLinkedProduct) return cart;

    const variantId = await getMembershipVariantId();
    if (!variantId) return;

    const membershipItems = cart.items.filter((item) =>
      item.variant_id === variantId &&
      item.selling_plan_allocation?.selling_plan?.id == SELLING_PLAN_ID
    );

    if (!membershipItems.length || !membershipItems.some((item) => item.quantity > 1)) return;

    const updates = {};
    membershipItems.forEach((item) => {
      updates[item.key] = 1;
    });

    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates })
      });

      if (response.ok) {
        const updatedCart = await response.json();
        publishMembershipCartUpdate(updatedCart);
      }
    } catch (error) {
      console.error("[Membership] Quantity enforcement failed:", error);
    }
  }

  async function enforceMembershipWelcomeGift(cart) {
    try {
      return await normalizeMembershipWelcomeGift(cart);
    } catch (error) {
      console.error("[Membership] Welcome gift enforcement failed:", error);
      return cart;
    }
  }

  document.addEventListener("cart-drawer:updated", (event) => {
    requestAnimationFrame(() => initializeCartUI(event.detail?.cartData));
  });

  document.addEventListener("cart-drawer:opened", (event) => {
    requestAnimationFrame(() => initializeCartUI(event?.detail?.cartData));
  });

  document.addEventListener("membership:updating", showMembershipLoading);
  document.addEventListener("membership:updated", hideMembershipLoading);

  if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
      if (event.source === "membership-linked") return;

      // MembershipLinkedProduct owns cart mutations. This script only updates
      // drawer UI while it is active, preventing duplicate cart reads and
      // quantity updates from racing the membership swap.
      if (window.membershipLinkedProduct) {
        if (hasFullCartSnapshot(event?.cartData)) {
          setLatestCart(event.cartData);
          await updateMembershipSavings(event.cartData);
        }
        return;
      }

      let cartData = hasFullCartSnapshot(event?.cartData) ? event.cartData : null;

      if (!cartData) {
        cartData = await resolveCartSnapshot(null, { forceFresh: true }).catch(() => null);
      }

      if (cartData) {
        setLatestCart(cartData);
        cartData = await enforceMembershipWelcomeGift(cartData);
        await enforceMembershipQuantity(cartData);
        await updateMembershipSavings(cartData);
      }
    });
  }

  bindMembershipDelegates();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeCartUI);
  } else {
    initializeCartUI();
  }
})();
